export const isExpression = (str: string) => {
  return /\{\{.*\}\}/.test(str)
}
